import type { ResultValue } from "../data/types";
import { OddsChip } from "./OddsChip";

interface OddsProps {
  oddsHome?: number;
  oddsAway?: number;
  oddsDraw?: number;
  result?: ResultValue;
  myRow?: ResultValue;
}

interface OutcomeOdds {
  odds?: number;
  sign: ResultValue;
}

export function Odds({
  myRow = "2",
  result,
  oddsHome,
  oddsAway,
  oddsDraw,
}: OddsProps): JSX.Element {
  if (oddsHome) {
    return (
      <>
        {availableOutcomes({ oddsHome, oddsAway, oddsDraw }).map(
          ({ sign, odds }) => (
            <OddsChip
              key={sign}
              sign={sign}
              odds={odds}
              mine={myRow === sign}
              correct={result === sign}
            />
          ),
        )}
      </>
    );
  }

  if (myRow) {
    return <OddsChip sign={myRow} mine correct={false} />;
  }

  return <></>;
}

function availableOutcomes({
  oddsHome,
  oddsAway,
  oddsDraw,
}: Pick<OddsProps, "oddsHome" | "oddsAway" | "oddsDraw">): OutcomeOdds[] {
  const homeOutcome: OutcomeOdds = { sign: "1", odds: oddsHome };
  const awayOutcome: OutcomeOdds = { sign: "2", odds: oddsAway };

  if (!oddsDraw) return [homeOutcome, awayOutcome];

  return [
    homeOutcome,
    { sign: "X", odds: oddsDraw },
    awayOutcome,
  ];
}
